var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nb-status",class:`nb-status-${_vm.type}`},[_c('NbIcon',{class:`status-text-${_vm.type}`,attrs:{"icon":"circle","attributes":{
      class: 'mb-1',
      fill: _vm.getTypeColor,
      width: '.4rem',
      height: '.4rem',
    }}}),_c('span',{class:`status-text ${_vm.classes}`},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }